import React from 'react';
import { styled } from '@mui/system';

const DivFlexSpaceBetween = styled('div')((props) =>({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
}));

export default DivFlexSpaceBetween;